import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createWorkspaceFeedback } from "api/services/workspace-service";
import { ICreateTrainingFeedbackRequest } from "api/models/request/feedback/ICreateTrainingFeedbackRequest";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { WORKSPACE_FEEDBACK_QUERY_KEY } from "hooks/feedback/queryKeys";

export const useCreateWorkspaceFeedback = () => {
    const queryClient = useQueryClient();
    const { callAPI } = useWorkspaceApiCall(
        createWorkspaceFeedback,
        "feedbackManagement.saveSuccess",
        "feedbackManagement.saveError"
    );

    const mutation = useMutation({
        mutationFn: async (request: ICreateTrainingFeedbackRequest): Promise<string | undefined> => {
            const response = await callAPI(request);
            if (!response?.success) {
                throw new Error(response?.message ?? "feedbackManagement.saveError");
            }

            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: WORKSPACE_FEEDBACK_QUERY_KEY });
        }
    });

    return {
        createFeedback: mutation.mutateAsync,
        creatingFeedback: mutation.isPending,
    };
};
